/*----------------------------------
- PUBLIC SEARCH READINESS
----------------------------------*/

/**
 * @docs docs/features/product-domain-listings
 * @adr  ADR-0028
 * @rule A public page renders a resolution only when Product marked it `ready_current` or
 *       `ready_stale`. `/domains` answers 503 otherwise; Home hides its preview. Both read this
 *       one predicate so the two pages can never disagree on what "ready" means.
 */

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import type { WebsitePublicSearchResolution } from '@/common/types/domains/publicSearch';

/*----------------------------------
- PUBLIC API
----------------------------------*/

export const isRenderablePublicSearchResolution = (
    resolution: WebsitePublicSearchResolution | null | undefined,
): resolution is WebsitePublicSearchResolution =>
    resolution?.readiness?.status === 'ready_current' || resolution?.readiness?.status === 'ready_stale';
